import React, { useContext } from "react";

import Navbar from "../partials/Navbar";
import Footer from "../partials/Footer";
import Sidebar from "../partials/About/Sidebar";

import { GlobalContext } from "../context/GlobalContext";

const Layout = (props) => {
  const { state, handleFunction } = useContext(GlobalContext);
  const { toggleSidebar } = state;
  const { sidebarClose } = handleFunction;

  return (
    <div className="flex flex-col text-sm 2xl:text-base max-w-screen-2xl mx-auto ">
      <Navbar aboutSidebar={props.aboutSidebar} />
      <Sidebar />
      <div className="mb-2 mt-16 lg:mt-24 lg:pl-52 xl:pl-60 lg:pr-20 xl:pr-24">
        <div>{props.children}</div>
      </div>
      <Footer />
      {toggleSidebar && (
        <div
          id="mesanfaz-drawer"
          onClick={sidebarClose}
          class="bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30"
        ></div>
      )}
    </div>
  );
};

export default Layout;
